import { Box, Link, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

// Maps markdown elements onto MUI components so answers match the admin UI.
const components = {
	p: ({ node, ...props }) => <Typography variant="body2" component="p" sx={{ fontSize: 15, lineHeight: 1.6, my: 1 }} {...props} />,
	h1: ({ node, ...props }) => <Typography variant="h3" component="h3" {...props} />,
	h2: ({ node, ...props }) => <Typography variant="h4" component="h4" {...props} />,
	h3: ({ node, ...props }) => <Typography variant="h4" component="h5" sx={{ fontSize: 16 }} {...props} />,
	ul: ({ node, ...props }) => <Box component="ul" sx={{ pl: 3, my: 1, fontSize: 15, lineHeight: 1.6 }} {...props} />,
	ol: ({ node, ...props }) => <Box component="ol" sx={{ pl: 3, my: 1, fontSize: 15, lineHeight: 1.6 }} {...props} />,
	li: ({ node, ...props }) => <Box component="li" sx={{ my: 0.25 }} {...props} />,
	strong: ({ node, ...props }) => <Box component="strong" sx={{ fontWeight: 700 }} {...props} />,
	a: ({ node, ...props }) => <Link target="_blank" rel="noreferrer noopener" {...props} />,
	code: ({ node, ...props }) => (
		<Box component="code" sx={{ fontFamily: "monospace", fontSize: 13, bgcolor: "grey.100", px: 0.5, borderRadius: 0.5 }} {...props} />
	),
	pre: ({ node, ...props }) => (
		<Box component="pre" sx={{ bgcolor: "grey.100", p: 1.5, borderRadius: 1, overflowX: "auto", "& code": { bgcolor: "transparent", p: 0 } }} {...props} />
	),
	table: ({ node, ...props }) => (
		<TableContainer sx={{ my: 1.5, border: 1, borderColor: "divider", borderRadius: 1, maxWidth: "100%" }}>
			<Table size="small" {...props} />
		</TableContainer>
	),
	thead: ({ node, ...props }) => <TableHead sx={{ bgcolor: "grey.50" }} {...props} />,
	tbody: ({ node, ...props }) => <TableBody {...props} />,
	tr: ({ node, ...props }) => <TableRow {...props} />,
	th: ({ node, style, ...props }) => <TableCell sx={{ fontWeight: 700, whiteSpace: "nowrap", textAlign: style?.textAlign ?? "left" }} {...props} />,
	td: ({ node, style, ...props }) => <TableCell sx={{ fontVariantNumeric: "tabular-nums", textAlign: style?.textAlign ?? "left" }} {...props} />,
};

export function Markdown({ children }) {
	return (
		<ReactMarkdown remarkPlugins={[remarkGfm]} components={components}>
			{children}
		</ReactMarkdown>
	);
}
